import React from 'react'
import izziIcon from '../assets/izziicon.svg'

const BotIcon = ({ sx, ...props }) => {
  return (
    <img
      src={izziIcon}
      alt="Izzi"
      style={{
        width: sx?.fontSize || '24px',
        height: sx?.fontSize || '24px',
        display: 'inline-block',
        verticalAlign: 'middle',
        ...sx
      }}
      {...props}
    />
  )
}

export default BotIcon